function t(){return n}function n(...o){}export{t as a};
